<template>
  <div >
      <el-form inline size="small">
        <el-form-item label="关键词">
          <el-input v-model="searchParams.word" placeholder="请输入" size="small" clearable ></el-input>
        </el-form-item>
        <el-form-item label="检测词分类">
          <!-- <el-select v-model="searchParams.lexicon_type" clearable placeholder="全部" class="w_120">
            <el-option v-for="item in Object.keys(lexiconType)" :value="item" :label="lexiconType[item].label" :key="item" ></el-option>
          </el-select> -->
          <el-select v-model="searchParams.lexicon_type" clearable placeholder="全部" class="w_220" multiple collapse-tags>
            <el-option v-for="item in dictionaryWordsList" :value="item.id" :label="item.dictionary_name" :key="item.id">
                <span style="float: left" >{{ item.dictionary_name }}</span>
                <span style="float: right; color: #e6a23c; font-size: 13px" v-if="item.merchant_id === 0">系统</span>
                <span style="float: right; color: #017eff; font-size: 13px" v-else>自配</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
          <el-button size="small" @click="refresh">重置</el-button>
        </el-form-item>
      </el-form>
    <div style="margin-bottom: 15px;">
      <el-button type="primary" plain :disabled="!selectData.length" size="small" @click="batchDelete">批量删除</el-button>
      <el-button type="success" size="small" @click="handleAdd">批量新增</el-button>
      <!-- <el-button type="warning" plain size="small" @click="handleShowWord('brand')">系统预配售假品牌词</el-button>
      <el-button type="warning" plain size="small" @click="handleShowWord('violation')">系统预配第三方诱导违规词</el-button> -->
      <el-button type="success" size="small" @click="handleDictionAdd">检测词分类管理</el-button>
    </div>
    <el-table v-loading="loading" :data="tableData" @selection-change="selectChange"
              :header-cell-style="{ background: '#eef1f6', color: '#606266' }" class="rc_table" row-key="id" >
      <el-table-column type="selection" align="center"  width="50"></el-table-column>
      <el-table-column label="序号" type="index" align="center" width="80" :selectable="checkSelectable"></el-table-column>
      <el-table-column label="关键词" prop="word" align="center"></el-table-column>
      <el-table-column label="分类" prop="status" align="center" >
        <template #default="{ row }">
          <el-tag size="small">{{ row.merchant_id == 0? '系统': '自配' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="检测词分类" prop="status" align="center" >
        <!-- <template #default="{ row }">
          <el-tag :type="lexiconType[row.lexicon_type].type" size="small">{{lexiconType[row.lexicon_type].label}}</el-tag>
        </template>
      </el-table-column> -->
        <template #default="{ row }">
          <el-tag size="small">{{ dictionaryWordsList.find(item => item.id === row.lexicon_type)?.dictionary_name || '未知' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="created_at" align="center"></el-table-column>

    </el-table>

    <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getDataList" layout="total, sizes, prev, pager, next, jumper" v-if="page_data.total>0" />

    <el-dialog title="新增关键词" :visible.sync="addShow" :close-on-click-modal="false">
      <el-form :model="addInfo" ref="addForm" label-width="100px" size="small">
        <el-form-item label="检测词分类" prop="lexicon_type" :rules="[{ required: true, message: '请选择检测词分类', trigger: 'change' }]">
          <el-select v-model="addInfo.lexicon_type">
            <el-option v-for="item in dictionaryWordsList" :value="item.id" :label="item.dictionary_name" :key="item.id" v-if="item.merchant_id !== 0 || ismanager">
                <span style="float: left" >{{ item.dictionary_name }}</span>
                <span style="float: right; color: #e6a23c; font-size: 13px" v-if="item.merchant_id === 0">系统</span>
                <span style="float: right; color: #017eff; font-size: 13px" v-else>自配</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键词" prop="keywords" :rules="[{ required: true, message: '请填写关键词', trigger: 'change', }]">
          <el-input type="textarea" :autosize="{minRows: 5,maxRows: 20}" v-model="addInfo.keywords" placeholder="填写格式示例：
测试1
测试2
测试3" size="small" clearable ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="addShow = false">取消</el-button>
        <el-button type="primary" @click="submitAdd" :loading="addLoading">确定</el-button>
      </template>
    </el-dialog>

    <el-dialog :title="wordType=='brand'?'系统预配售假品牌词':'系统预配第三方诱导违规词'" :visible.sync="wordShow" :close-on-click-modal="false">
      <div class="word-box">
        <el-tag  v-for="(item,index) in wordList" :key="index" style="margin: 0 6px 6px 0">{{item}}</el-tag>
      </div>

    </el-dialog>
    <DictionaryWords @dataChange="handleSearch" :dialog_visible.sync="dictionary_dialog_visible" :dictionary_type="2" :initList.sync="dictionaryWordsList"></DictionaryWords>
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";

import Pagination from "@/components/pagination/pagination.vue";
import DictionaryWords from "@/components/dictionaryWords/dictionaryWords.vue";


export default {
  components: {
    Pagination,
    DictionaryWords,
  },
  computed:{
    ...mapState({
        users:(state)=>state.login.userinfo
    })
  },
  data() {
    return {
      dataInfo:{},
      loading: false,
      tableData: [],
      page_data: {
        limit: 10,
        page: 1,
        total:0,
      },
      searchParams:{
        word:'',
        type:'',
        lexicon_type:''
      },
      selectData:[],
      lexiconType:{
        1: {label:'售假品牌词',type:'error'},
        2: {label:'第三方诱导违规',type:'warning'},
      },

      addShow:false,
      addInfo:{type:'',lexicon_type:"",keywords:""},
      addLoading:false,

      wordShow:false,
      wordList:[],
      wordType:'',
      systemBrandWord:[],
      systemViolationWord:[],
      dictionaryWordsList:[],
      dictionary_dialog_visible: false,
    }
  },
  created() {
    this.ismanager = this.users.mer_user_id === '1'
    this.handleSearch()
  },

  methods: {
    ...mapActions({
      getImgKeywordList: 'ucenter/getImgKeywordList',
      opImgKeywordAdd: 'ucenter/opImgKeywordAdd',
      opImgKeywordDelete: 'ucenter/opImgKeywordDelete',
      opGetDictionaryWords: 'ucenter/opGetDictionaryWords',
    }),
    handleDictionAdd(){
        this.dictionary_dialog_visible = true;
    },
    checkSelectable(row){
        console.log(1111);

        if (row.merchant_id === 0) {
            return this.ismanager === true;
        }
        return true;
    },
    handleShowWord(type){
      this.wordType = type
      if(type=='brand'){
        this.wordList = this.systemBrandWord
      }else{
        this.wordList = this.systemViolationWord
      }
      this.wordShow = true
    },
    //获取盲盒列表
    getDataList() {
      this.loading = true
      let param = {page_size:this.page_data.limit,page:this.page_data.page,batch_id:this.batchId,...this.searchParams}
      this.getImgKeywordList({
        data: param,
        success: (res) => {
          this.loading = false
          console.log(res)
          if (res.code == 200) {
            this.tableData = res.data.list
            this.page_data.total = res.data.total
            // this.systemBrandWord = res.data.system_brand_word.filter(item => (item!=='-' && item!==''));
            // this.systemViolationWord = res.data.system_violation_word.filter(item => (item!=='-' && item!==''));
          } else {
            this.$message.error(res.message)
          }

        }
      })
    },
    getDictionaryWords() {
      this.opGetDictionaryWords({
        data: {'dictionary_type': 2},
        success: (res) => {
          if (res.code == 200) {
            let list = res.data || [];
            list.sort((a, b) => (a.merchant_id === 0 ? -1 : 0));
            this.dictionaryWordsList = list;
          } else {
            this.$message.error(res.message)
          }

        }
      })
    },

    handleSearch(){
      this.page_data.page = 1
      this.getDictionaryWords()
      this.getDataList()
    },
    refresh(){
      this.page_data.page = 1
      this.page_data.total = 0
      this.searchParams = {
        word:'',
        type:'',
        lexicon_type:''
      }
      this.getDataList()
    },
    selectChange(e){
      this.selectData = [...e]
    },
    //批量删除
    batchDelete(){
      this.$confirm(`是否确定删除${this.selectData.length}个关键词?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opImgKeywordDelete({
          data: {ids:this.selectData.map(item=>item.id).join(',')},
          success: (res) => {
            if (res.code == 200) {
              this.$message.success('删除成功')
              this.getDataList()
            } else {
              this.$message.error(res.message)
            }
          }
        })
      })
    },

    // === 新增 ===
    handleAdd(){
      this.addShow = true
      this.addInfo = {type:'',lexicon_type:"",keywords:""}
     this.$nextTick(()=>{
       this.$refs.addForm.resetFields()
     })
    },
    submitAdd(){
      this.$refs.addForm.validate(valid => {
        if(valid){
          const words = this.addInfo.keywords.split(/\r\n|\r|\n|,|，/g).map(item => item.trim()).filter(item => (item !== '' && item !== '-'))
          const params = {
            // type:  this.addInfo.type,
            lexicon_type:  this.addInfo.lexicon_type,
            words: words.join(',')
          }
          this.addLoading = true
          this.opImgKeywordAdd({
            data: params,
            success: (res) => {
              if (res.code == 200) {
                this.$message.success('添加成功')
                this.addShow = false
                this.refresh()
              } else {
                this.$message.error(res.message)
              }
              this.addLoading = false
            }
          })
        }
      })

    },


  }
}
</script>


<style scoped>
.w_120{
  width: 150px;
}
.word-box{
  max-height: 60vh;
  overflow-y: auto;
}
</style>
